(function () {

  var params = new URLSearchParams(window.location.search);

  var kioskParam = params.get('kiosk');

  if (kioskParam === '1') {

    localStorage.setItem('kioskMode', 'true');

  } else if (kioskParam === '0') {

    localStorage.removeItem('kioskMode');

  }

  if (localStorage.getItem('kioskMode') === 'true') {

    document.documentElement.classList.add('kiosk-mode');

  }

})();